module.exports = __webpack_public_path__ + "static/media/bz.09219a89.svg";